import React from 'react';
import dayjs from 'dayjs';
import { calculateAge } from '../../Registrationform/helpers/calculateAge';
import { useDispatch, useSelector } from 'react-redux';
import { capitalizeFirstLetter } from '../../../utils/common';
import { renderInputFieldWithoutLabel } from '../../../common/inputField';

export const EmbryologyProfile = ({ isSummary, handleInputChange }) => {
  const dispatch = useDispatch();

  const selectedPatientData = useSelector(
    (state) => state.embryologyReducer.selectedPatientData,
  );

  const summary = useSelector((state) => state.embryologyReducer.summary);

  return (
    <>
      <div className="customer-profile">
        <h3>Customer Profile</h3>
        <div className="card" style={{ padding: 5 }}>
          <div className="body">
            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  {' '}
                  Patient Name:
                </strong>
                <span style={{ flexGrow: 1 }}>
                  {selectedPatientData.patient.firstName}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>Age:</strong>
                <span style={{ flexGrow: 1 }}>
                  {calculateAge(dayjs(selectedPatientData.patient.dob))}
                </span>
              </div>

              {!isSummary && (
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Mobile:
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {selectedPatientData.patient.phone}
                  </span>
                </div>
              )}

              {isSummary && (
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Aadhar:
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {selectedPatientData.patient.adharNumber}
                  </span>
                </div>
              )}
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  MPI No:
                </strong>
                <span style={{ flexGrow: 1 }}>
                  {selectedPatientData.patient.upid}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Gender:
                </strong>
                <span style={{ flexGrow: 1 }}>
                  {capitalizeFirstLetter(selectedPatientData.patient.gender)}
                </span>
              </div>

              {!isSummary && (
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Email Id:
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {selectedPatientData.patient.email}
                  </span>
                </div>
              )}
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  {' '}
                  Husband Name:
                </strong>
                <span style={{ flexGrow: 1 }}>
                  {selectedPatientData.patient.partner.firstName}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>Age:</strong>
                <span style={{ flexGrow: 1 }}>
                  {calculateAge(dayjs(selectedPatientData.patient.partner.dob))}
                </span>
              </div>

              {!isSummary && (
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Mobile:
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {selectedPatientData.patient.partner.phone}
                  </span>
                </div>
              )}

              {isSummary && (
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Aadhar:
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {selectedPatientData.patient.partner.adharNumber}
                  </span>
                </div>
              )}
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  MPI No:
                </strong>
                <span style={{ flexGrow: 1 }}>
                  {selectedPatientData.patient.upid}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Gender:
                </strong>
                <span style={{ flexGrow: 1 }}>
                  {capitalizeFirstLetter(
                    selectedPatientData.patient.partner.gender,
                  )}
                </span>
              </div>

              {!isSummary && (
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Email Id:
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {selectedPatientData.patient.partner.email}
                  </span>
                </div>
              )}
            </div>
            {isSummary && (
              <div
                className="row clearfix"
                style={{ alignItems: 'center', marginBottom: '15px' }}
              >
                <div
                  className="flex col-md-4"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <strong style={{ flexShrink: 0, width: '100px' }}>
                    Treating Doctor
                  </strong>
                  <span style={{ flexGrow: 1 }}>
                    {renderInputFieldWithoutLabel(
                      'treatingDoctor',
                      summary.treatingDoctor,
                      handleInputChange,
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
